<template>
  <ul class="info__list">
    <li class="info__item">
      Стоимость:
      <span class="info__num info__num--sum">
        {{ data.price !== 0 ? currentData.price : '-', }}
      </span>
    </li>
    <li class="info__item">
      Подписано:
      <span class="info__num info__num--signature">
        {{ data.signed !== 0 ? currentData.signed : '-', }}
      </span>
    </li>
    <li class="info__item">
      Остаток:
      <span class="info__num info__num--balance">
        {{ data.remains !== 0 ? currentData.remains : '-' }}
      </span>
    </li>
  </ul>
</template>

<script>
import { priceFormat } from '@/utils/form/priceFormat'

export default {
  name: 'PtoPriceInfoList',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    currentData: {
      price: 0,
      signed: 0,
      remains: 0
    }
  }),
  mounted () {
    if (this.data.price && this.data.price !== 0) this.currentData.price = priceFormat(this.data.price)
    if (this.data.signed && this.data.signed !== 0) this.currentData.signed = priceFormat(this.data.signed)
    if (this.data.remains && this.data.remains !== 0) this.currentData.remains = priceFormat(this.data.remains)
  }
}
</script>
